export default {
  cookie_name: 'gw_cookie_consent',
  expiration_time: 365,
  user_choices: [],
}
